import {
  mathUtilities
} from "./chunk.DOXHQ6SA.js";
import {
  timer_styles_default
} from "./chunk.LLIFVJZE.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/timer/timer.ts
import { t as t2 } from "i18next";
var secondMs = 1e3;
var minuteMs = 6e4;
var hourMs = 36e5;
var FadvTimer = class extends s {
  constructor() {
    super(...arguments);
    this.duration = 0;
    this.variant = "primary";
    this.end = 0;
    this.remaining = 0;
    this.liveText = "";
    this.countText = "";
    this.running = false;
  }
  computeTimeRemaining() {
    const { remaining } = this;
    const hour = Math.floor(remaining / hourMs);
    const min = this.pad(hour, Math.floor(remaining / minuteMs % 60));
    const secValue = Math.floor(remaining % minuteMs / secondMs);
    const sec = this.pad(min, secValue);
    const hun = this.pad(true, Math.floor(remaining % secondMs / 10));
    const hundredths = this.hundredths ? `:${hun}` : "";
    if (remaining >= hourMs) {
      this.liveText = t2("components:timer.hoursLiveText", { hour, min });
      this.countText = `${hour}:${min}:${sec}${hundredths}`;
    } else if (remaining <= hourMs && remaining >= minuteMs) {
      this.liveText = t2("components:timer.minutesLiveText", { min });
      this.countText = `${min}:${sec}${hundredths}`;
    } else if (remaining < minuteMs && remaining > 0) {
      if (secValue % 10 === 0) {
        this.liveText = t2("components:timer.secondsLiveText", { secValue });
      } else if (secValue <= 5) {
        this.liveText = `${secValue}`;
      }
      this.countText = `${sec}${hundredths}`;
    } else {
      if (this.endMessage) {
        this.liveText = ``;
        this.countText = ``;
      } else {
        this.liveText = `0`;
        this.countText = `0`;
      }
      this.running = false;
      emit(this, "timer-elapsed");
    }
  }
  pause() {
    if (!this.running)
      return;
    this.running = false;
    this.end = 0;
    emit(this, "timer-paused");
  }
  pad(pad, val) {
    return pad ? val.toString().padStart(2, "0") : val;
  }
  getProgress(remain) {
    const progressValue = parseFloat(mathUtilities.map(remain, this.hundredths ? 0 : secondMs, this.duration, 0, 100).toFixed(1));
    return +Math.max(0, progressValue) || 0;
  }
  renderMessage() {
    if (this.remaining >= minuteMs) {
      return $`<div class="timer__time-left">${t2("components:timer.timeLeft")}</div>`;
    }
    if (this.remaining < minuteMs && this.remaining > 0 || this.remaining <= 0 && !this.endMessage) {
      return $`<div class="timer__sec">${t2("components:timer.secondsLabel")}</div>`;
    }
    return $`<div class="timer__message">${this.endMessage}</div>`;
  }
  renderRestart() {
    if (this.running)
      return w;
    if (!this.showStart)
      return w;
    if (!this.showRestart)
      return w;
    if (this.remaining > 0)
      return w;
    return $`<fadv-button @click=${this.restart} class="timer__button" variant="text"><fadv-icon name="fa-arrow-rotate-left" library="solid" foreground="${this.variant}" size="small" label="${t2("components:timer.restartLabel")}" ></fadv-icon></fadv-button>`;
  }
  renderStart() {
    if (!this.showStart || this.remaining === 0)
      return w;
    if (!this.running)
      return $`<fadv-button @click=${this.start} class="timer__button" variant="text"><fadv-icon name="fa-play" library="solid" foreground="${this.variant}" size="small" label="${t2("components:timer.startLabel")}"></fadv-icon></fadv-button>`;
    return $`<fadv-button @click=${this.pause} class="timer__button" variant="text"><fadv-icon name="fa-pause" library="solid" foreground="${this.variant}" size="small" label="${t2("components:timer.pauseLabel")}"></fadv-icon></fadv-button>`;
  }
  reset() {
    this.running = false;
    this.remaining = this.duration;
    this.computeTimeRemaining();
    if (this.autostart) {
      this.start();
    }
  }
  start() {
    if (this.running)
      return;
    this.running = true;
    this.end = Date.now() + this.remaining;
    this.tick();
    emit(this, "timer-started");
  }
  restart() {
    this.reset();
    this.start();
  }
  tick() {
    if (this.running) {
      const remainingValue = this.end - Date.now();
      if (!this.hundredths && remainingValue <= secondMs) {
        this.remaining = 0;
      } else {
        this.remaining = Math.max(0, remainingValue);
      }
      this.computeTimeRemaining();
      requestAnimationFrame(() => this.tick());
    }
  }
  firstUpdated() {
    this.reset();
  }
  render() {
    return $`<div part="base" class=${o({
      timer: true,
      "timer--complete": this.remaining === 0,
      "timer--has-hours": this.remaining >= hourMs,
      "timer--has-hundredths": this.hundredths,
      "timer--has-start": this.showStart,
      "timer--seconds-only": this.remaining < minuteMs,
      [`timer--${this.variant}`]: true
    })} role="timer" ><fadv-visually-hidden class="timer__live-region" aria-atomic="true" aria-live="assertive">${this.liveText}</fadv-visually-hidden><fadv-progress-ring timer="true" variant="${this.variant}" .value=${this.getProgress(this.remaining)} class="timer__progress-ring"><div class="timer__content"><div class="timer__count">${this.countText}</div><div class="timer__message">${this.renderMessage()}</div></div></fadv-progress-ring><div class="timer__controls-container"><div class="timer__controls">${this.renderStart()}</div><div class="timer__controls">${this.renderRestart()}</div></div></div>`;
  }
};
FadvTimer.styles = timer_styles_default;
__decorateClass([
  e({ type: Boolean })
], FadvTimer.prototype, "autostart", 2);
__decorateClass([
  e({ type: Number })
], FadvTimer.prototype, "duration", 2);
__decorateClass([
  e({ type: String })
], FadvTimer.prototype, "endMessage", 2);
__decorateClass([
  e({ type: Boolean })
], FadvTimer.prototype, "hundredths", 2);
__decorateClass([
  e({ type: Boolean })
], FadvTimer.prototype, "showStart", 2);
__decorateClass([
  e({ type: Boolean })
], FadvTimer.prototype, "showRestart", 2);
__decorateClass([
  e({ reflect: true })
], FadvTimer.prototype, "variant", 2);
__decorateClass([
  t()
], FadvTimer.prototype, "end", 2);
__decorateClass([
  t()
], FadvTimer.prototype, "remaining", 2);
__decorateClass([
  t()
], FadvTimer.prototype, "liveText", 2);
__decorateClass([
  t()
], FadvTimer.prototype, "countText", 2);
__decorateClass([
  t()
], FadvTimer.prototype, "running", 2);
__decorateClass([
  watch("duration", { waitUntilFirstUpdate: true }),
  watch("autostart", { waitUntilFirstUpdate: true })
], FadvTimer.prototype, "reset", 1);
FadvTimer = __decorateClass([
  n("fadv-timer")
], FadvTimer);

export {
  FadvTimer
};
